import { motion, type Variants } from "motion/react";

import { m } from "@/paraglide/messages.js";

const EASE = [0.25, 0.1, 0.25, 1] as const;

const statementVariants: Variants = {
  hidden: { opacity: 0, y: 22, filter: "blur(8px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.7, ease: EASE },
  },
};

const viewport = { once: true, margin: "-80px" } as const;

/**
 * Single oversized positioning line that breaks the bento grid rhythm. Blurs
 * up into focus as the section scrolls into view.
 */
export const StatementSection = () => {
  return (
    <section className="mx-auto w-full max-w-[1320px] px-5 py-12 md:py-20">
      <motion.p
        className="mx-auto max-w-[1024px] text-center italic text-2xl font-medium leading-snug text-foreground md:text-4xl lg:text-5xl md:leading-[56px]"
        variants={statementVariants}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
      >
        {m.landing_statement()}
      </motion.p>
    </section>
  );
};
